import MGTokenForm from "./MGTokenForm";

export default MGTokenForm;
